export const textColorTransition = `transition-[color] ease-custom duration-500`
